import { auth } from "firebase";
import { checkIfAdmin } from "@/services/server.js";

export const firebaseLogin = function(callback) {
  const provider = new auth.GoogleAuthProvider();

  auth()
    .signInWithPopup(provider)
    .then(result => callback(undefined, result))
    .catch(err => callback(err));
};

export async function getFirebaseUser(id_token) {
  const credential = auth.GoogleAuthProvider.credential(id_token);
  return await auth().signInAndRetrieveDataWithCredential(credential);
}

export const processFirebaseUser = function({
  displayName,
  email,
  photoURL,
  refreshToken
}) {
  return {
    displayName,
    email,
    photoURL,
    refreshToken,
    isAdmin: checkIfAdmin(email)
  };
};

// Use this in production; change whatver calls this to use a callback
export const prodProcessFirebaseUser = function(
  { displayName, email, photoURL },
  callback
) {
  const user = {
    displayName,
    email,
    photoURL,
    isAdmin: false
  };
  checkIfAdmin(email, (err, result) => {
    if (!err && !!result) {
      user.isAdmin = true;
    }
    callback(err, user);
  });
};
